export type AppStoreType = 'android' | 'ios'

/** Infers iOS App Store vs Google Play from `navigator.userAgent` for install-banner routing. */
export const getAppStoreTypeFromUserAgent = (
  userAgent: string | undefined,
): AppStoreType | null => {
  if (!userAgent) return null

  const lowerCaseUserAgent = userAgent.toLowerCase()
  if (lowerCaseUserAgent.includes('android')) return 'android'
  if (/iphone|ipad|ipod/.test(lowerCaseUserAgent)) return 'ios'
  return null
}
